/**
 * This is the top level data component of all the classes.
 * Ultimately it will contain all the other elements (Label, Row, Seat, Path...etc.)
 * @class DataSection
 */
export default class DataSection {
  constructor (opts) {
    opts = opts || {};

    /**
     * This is the unique identifier for this section.
     * `opts.id = "s_3"`
     * @type {String} */
    this.id = opts.id;

    /**
     * This is the section code.
     * `opts.id = "TF-104"`
     * @type {String} */
    this.code = opts.code;

    /**
     * TODO, check if still needed
     *
     * @type {String} */
    this.name = opts.name;

    /**
     * This should get the number of available seats in a section
     * @type {Number} */
    this.availableSeatCount = opts.availableSeatCount;

    /**
     * This is the single label object that appears on top of the section polygon
     * @type {DataLabel} */
    this.label = opts.label;

    /**
     * This is the geometrical Polygon that represents the section block
     * @type {DataPolygon} */
    this.polygon = opts.polygon;

    /**
     * Flag if the section is GA, the seats will not be rendered but calculated
     * @type {DataPolygon} */
    this.isGA = opts.isGA;

    /**
     * This is the list of all the rows that compose a section
     * @type {Array<DataRow>} */
    this.rows = opts.rows;

    /**
     * This is the position point focus for the section. Rotations and translations happen around this point.
     * @type {Point} */
    this.position = opts.position;

    /**
     * Define how much to translate horizontally or vertically the seat block.
     * section.translate.x translates horizontally
     * section.translate.y translates vertically
     * @type {DataPoint} */
    this.translate = opts.translate;

    /** @type {Number} */
    this.angle = opts.angle;

    /** @type {Array<String>} */
    this.priceCategories = opts.priceCategories;

    /** @type {Map<String:Number>} */
    this.priceCategoryAvailability = opts.priceCategoryAvailability || {};

    /** @type {Number} */
    this.size = opts.size;
  }
}



// WEBPACK FOOTER //
// ./frontend/react/sim/schemas/Section.js